// extracted by mini-css-extract-plugin
module.exports = {"paneNote":"PaneNote__paneNote__Nv3AE"};